import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markShipmentReady } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useReadyShipment = () => {

  const queryClient = useQueryClient();

  return useMutation({

    mutationFn: (shipmentCode) =>
      markShipmentReady(shipmentCode),

    onSuccess: (_, shipmentCode) => {

      queryClient.invalidateQueries(shipmentKeys.all);

      queryClient.invalidateQueries(
        shipmentKeys.detail(shipmentCode)
      );
    },

  });

};
